import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useSwapTransactionStore = create(persist((set) => ({
    swapTransactions: {},
    setSwapTransaction: (Id, status, txHash, failReason) => {
        set((state) => {
            const txForSwap = {
                ...state.swapTransactions,
                [Id]: {
                    hash: txHash,
                    status: status,
                    failReason: failReason,
                    timestamp: Date.now()
                }
            };
            return { swapTransactions: txForSwap };
        });
    },
    removeSwapTransaction: (id) => {
        set((state) => {
            const { [id]: deletedTransaction, ...remainingTransactions } = state.swapTransactions;
            return { swapTransactions: remainingTransactions };
        });
    },
}), {
    name: 'swapTransactions',
    storage: createJSONStorage(() => localStorage),
}));
export const useGaslessAuthorizationStore = create(persist((set) => ({
    authorizations: {},
    setGaslessAuthorization: (Id, validBefore) => {
        set((state) => ({
            authorizations: {
                ...state.authorizations,
                [Id]: { validBefore },
            },
        }));
    },
    setGaslessAuthorizationStatus: (Id, status, transaction) => {
        set((state) => {
            // A late poll response must not resurrect an authorization that
            // retry cleanup already removed — recreating it with validBefore: 0
            // would immediately re-expire the fresh attempt.
            const current = state.authorizations[Id];
            if (!current)
                return state;
            return {
                authorizations: {
                    ...state.authorizations,
                    [Id]: {
                        ...current,
                        status,
                        transaction: transaction ?? current.transaction ?? null,
                    },
                },
            };
        });
    },
    removeGaslessAuthorization: (Id) => {
        set((state) => {
            const { [Id]: _removed, ...remaining } = state.authorizations;
            return { authorizations: remaining };
        });
    },
}), {
    name: 'gaslessAuthorizations',
    storage: createJSONStorage(() => localStorage),
}));
export const useSwapDepositHintClicked = create(persist((set, get) => ({
    swapTransactions: {},
    setSwapDepositHintClicked: (Id) => {
        set((state) => {
            const txForSwap = {
                ...state.swapTransactions,
                [Id]: true
            };
            return { swapTransactions: txForSwap };
        });
    },
}), {
    name: 'swapDepositHintClicked',
    storage: createJSONStorage(() => sessionStorage),
}));
